import { Grid, Layout } from 'antd';
import React from 'react';
import { Sider } from './custom-navigation';

const CustomLayout: React.FC = ({ children }) => {
  const breakpoint = Grid.useBreakpoint();

  return (
    <Layout style={{ backgroundColor: '#F1F6FD', minWidth: 0, overflowX: 'hidden' }}>
      <Sider />
      <Layout style={{ backgroundColor: '#F1F6FD', padding: breakpoint.md ? 12 : 0, minWidth: 0 }}>
        {children}
      </Layout>
    </Layout>
  );
};

export default CustomLayout;
